import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { GetUser, GetPayment } from "../../Services";

const AddDepositForm = ({ setShowModal, setPayments }) => {
  const [drivers, setDrivers] = useState([]);
  const [formData, setFormData] = useState({
    driver_id: "",
    amount: "",
    payment_mode: "CASH",
  });

  // ✅ Fetch drivers for the select dropdown
  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const res = await GetUser.fetchDriverList();
        setDrivers(Array.isArray(res.drivers) ? res.drivers : []);
      } catch (error) {
        console.error("Error fetching drivers:", error);
        toast.error("Failed to fetch drivers.");
      }
    };
    fetchDrivers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.driver_id || !formData.amount || !formData.payment_mode) {
      toast.error("Please fill in all fields.");
      return;
    }

    try {
      const res = await GetPayment.createDeposite({
        driverId: formData.driver_id,
        amount: parseFloat(formData.amount),
        mode: formData.payment_mode,
      });

      toast.success("Deposit added successfully!");
      setPayments((prev) => [res.payment, ...prev]);
      setShowModal(false);
    } catch (error) {
      console.error("Error creating deposit:", error);
      toast.error("Failed to add deposit. Please try again.");
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <h2 className="text-xl font-semibold mb-4">Add Deposit</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Driver select */}
        <div className="form-group">
          <label className="block text-sm font-medium mb-1">
            Select Driver
          </label>
          <select
            name="driver_id"
            value={formData.driver_id}
            onChange={handleChange}
            className="form-control"
            required
          >
            <option value="">-- Choose Driver --</option>
            {drivers.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name || d.full_name} ({d.id})
              </option>
            ))}
          </select>
        </div>

        {/* Amount input */}
        <div className="form-group">
          <label className="block text-sm font-medium mb-1">Amount</label>
          <input
            type="number"
            min="0"
            step="0.01"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            placeholder="Enter deposit amount"
            className="form-control"
            required
          />
        </div>

        {/* Payment mode select */}
        <div className="form-group">
          <label className="block text-sm font-medium mb-1">Payment Mode</label>
          <select
            name="payment_mode"
            value={formData.payment_mode}
            onChange={handleChange}
            className="form-control"
            required
          >
            <option value="CASH">Cash</option>
            <option value="BANK_TRANSFER">Bank Transfer</option>
            <option value="MOBILE_MONEY">Mobile Money</option>
          </select>
        </div>

        {/* Submit */}
        <button type="submit" className="btn btn-primary w-full">
          Add Deposit
        </button>
      </form>
    </div>
  );
};

export default AddDepositForm;
